// import { useQuery } from "@tanstack/react-query";

export default function History() {
  // Content fetching disabled for static site
  // const { data: content } = useQuery({
  //   queryKey: ["/api/content/history"],
  // });

  const timelineEvents = [
    {
      year: "1968",
      title: "The Beginning",
      description: "VCA started with 5 keelboats moored in Aloe Fjord, accessed through the Resort. The sheltered mooring attracted yachts from other areas and membership began to grow.",
      image: "/attached_assets/VCA photos (359) - Copy_1750074778100.jpg",
      alt: "Early yacht mooring at Aloe Fjord"
    },
    {
      year: "1969-1971",
      title: "Official Formation",
      description: "First AGM with 33 members under Commodore John Harrison. VCA joined TSA and SAYRA in 1971. Members constructed the first slipway when water levels dropped, and Hal Williams won the inaugural 100-mile race.",
      image: "/attached_assets/VCA photos (587) - Copy_1750074778094.jpg",
      alt: "Early VCA sailing activities on Vaal Dam"
    },
    {
      year: "1972-1977",
      title: "First Clubhouse Era",
      description: "Under Commodore John Aldersley, the first clubhouse was erected and hosted major championships. Membership grew to 200 members with 100 boats. The club relocated to its present site in 1976.",
      image: "/attached_assets/IMG-20250612-WA0089 - Copy_1750074778099.jpg",
      alt: "VCA clubhouse and facilities development"
    },
    {
      year: "1980s",
      title: "Land Ownership & Development",
      description: "Drought years brought challenges but also opportunities. Members extended slipways, built jetties, and installed the swimming pool. In 1990, VCA finally purchased the land, becoming property owners after 22 years.",
      image: "/attached_assets/VCA photos (51) - Copy_1750074778100.JPG",
      alt: "VCA infrastructure during land development years"
    },
    {
      year: "1990s",
      title: "Property Development",
      description: "With land ownership secured, VCA developed caravan sites, improved facilities, and established better infrastructure. The club gained its first full-time Grounds Manager and introduced junior sailing programs.",
      image: "/attached_assets/VCA photos (554) - Copy_1750074778100.JPG",
      alt: "VCA property and facility improvements"
    },
    {
      year: "2000-2001",
      title: "New Millennium Upgrades",
      description: "Under Commodore Michael Wright, VCA installed sliding gates, improved security lighting, added 15 amp power points at the floating jetty, completed the manager's cottage and games room, and established a development sailing program.",
      image: "/attached_assets/VCA photos (562)_1750074778101.jpg",
      alt: "Modern VCA clubhouse and amenities"
    },
    {
      year: "2002-2004",
      title: "Frank Lenz Era",
      description: "Commodore Frank Lenz embodied the spirit of hands-on leadership that defined VCA's golden years. A skilled craftsman and passionate sailor, Frank threw his heart and soul into the club for two transformative years. Working tirelessly alongside Dave Kilshaw, Frank could be found most weekends with tools in hand - welding, cutting, and building improvements to club facilities. His dedication extended beyond maintenance; Frank was a competitive racer who proudly flew the VCA flag in inter-club competitions, establishing a tradition of excellence that would define the club for years to come.",
      image: "/attached_assets/Frank_1750076292441.jpg",
      alt: "Commodore Frank Lenz in formal VCA uniform"
    },
    {
      year: "2005-2006",
      title: "Judith Edwards - First Lady Commodore",
      description: "Judith Edwards became VCA's first female Commodore, bringing a new atmosphere by ensuring wives and children were also engaged. She established themed monthly supper evenings, re-established club racing, and solved the 15-year hot water problem in ablutions.",
      image: "/attached_assets/Judith_1750142726500.jpg",
      alt: "Judith Edwards, VCA's first female Commodore"
    },
    {
      year: "2006-2008",
      title: "Racing Excellence",
      description: "Under Commodore Ken Baisley, VCA won the inter-club racing trophy for the fifth consecutive year. Major upgrades included road improvements, new tractor and rescue boat, and enhanced clubhouse facilities with dual TV controls.",
      image: "/attached_assets/Vaal dam 023 - Copy_1750074778099.jpg",
      alt: "VCA racing excellence on Vaal Dam"
    },
    {
      year: "2008-2010",
      title: "40th Anniversary & Frank's Return",
      description: "Frank Lenz returned as Commodore during VCA's 40th anniversary celebrations. The club achieved financial health while upgrading clubhouse and ablution roofs, sinking new boreholes, and winning the inter-club trophy for the sixth and seventh years.",
      image: "/attached_assets/Frank 2_1750076292440.jpg",
      alt: "Frank Lenz on the Vaal Dam during his second term as Commodore"
    },
    {
      year: "2010-2013",
      title: "Infrastructure Focus",
      description: "Peter Wiemann and Deon Wessels led infrastructure improvements including undercover walkways, pool refurbishment, outboard motor shed, and solar heating installation. The club maintained its racing trophy dominance and recognized long-serving staff.",
      image: "/attached_assets/VCA photos (589) - Copy_1750074778096.jpg",
      alt: "VCA infrastructure and facility improvements"
    },
    {
      year: "2013-2016",
      title: "Challenges & Championships",
      description: "Under Squib Raath and Frank Lenz's final term, VCA hosted the Hunter Nationals and participated in J22 World Series. Despite challenges including staff issues and declining sailing interest, major renovations were completed with Eric Leach's assistance.",
      image: "/attached_assets/VCA photos (623) - Copy_1750074778096.jpg",
      alt: "VCA hosting national sailing championships"
    },
    {
      year: "2016-2019",
      title: "Stability & Growth",
      description: "Peter Nicholl and Harry Basson maintained financial stability through economic challenges. Major achievements included clubhouse retiling, new water tanks, enhanced security systems, pool refurbishment, and hosting Formula One Nationals in 2019.",
      image: "/attached_assets/VCA photos (751) - Copy_1750074778096.jpg",
      alt: "Modern VCA club stability and growth"
    },
    {
      year: "2019-2021",
      title: "Naas van Wyk - Modernization & Resilience",
      description: "Naas van Wyk led VCA through significant challenges including economic pressures and the COVID-19 pandemic. His tenure focused on modernizing club operations, improving member communication, and maintaining facilities during unprecedented times. The club adapted to COVID-19 challenges while implementing major improvements. A new bar area was completed with overwhelmingly positive member feedback, a dedicated barman was appointed, and comprehensive security upgrades included motorized gates and complete electrical fencing around the boatyard.",
      image: "/attached_assets/VCA photos (771) - Copy_1750074778097.jpg",
      alt: "VCA modernization during challenging times"
    },
    {
      year: "2021-2023",
      title: "Paul Van Zijl - COVID Recovery & Innovation",
      description: "Paul continued building community spirit through the new bar operations during COVID-19 restrictions, installing a POS system and reducing costs. Major infrastructure projects included road maintenance equipment, kitchen upgrades with new stoves and braai areas, and introducing donated Halcats for recreational sailing. Security measures were implemented after the first break-in in six years.",
      image: "/attached_assets/VCA photos (771) - Copy_1750074778097.jpg",
      alt: "VCA during COVID recovery period with new facilities"
    },
    {
      year: "2023-2025",
      title: "Hernus de Lange - Solar Innovation & Infrastructure",
      description: "Hernus led VCA into sustainable energy with a grid-tied solar system installation, cutting electricity costs by one-third. During extreme water level fluctuations (20% to 120%), he orchestrated massive foreshore clearing projects, built additional boat yard sheds, enclosed the stoep braai area, and upgraded the camera monitoring system with member donations.",
      image: "/attached_assets/VCA photos (554) - Copy_1750074778100.JPG",
      alt: "Modern VCA with solar installation and infrastructure improvements",
      highlight: true
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">History of VCA</h1>
          <p className="text-xl text-gray-600">Over 55 years of boating excellence on the Vaal Dam since 1968</p>
        </div>

        <div className="relative">
          {/* Timeline */}
          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-0.5 h-full w-0.5 bg-navy"></div>
          
          <div className="space-y-12">
            {timelineEvents.map((event, index) => (
              <div key={event.year} className={`relative flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} md:items-center`}>
                <div className="md:w-1/2 md:px-8">
                  <div className={`rounded-lg p-6 ${event.highlight ? 'bg-navy text-white' : 'bg-gray-50'}`}>
                    <div className="absolute left-2 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 bg-sailing-gold rounded-full border-4 border-white"></div>
                    <h3 className={`text-xl font-bold mb-2 ${event.highlight ? 'text-white' : 'text-navy'}`}>
                      {event.year} - {event.title}
                    </h3>
                    <p className={event.highlight ? 'text-white' : 'text-gray-700'}>
                      {event.description}
                    </p>
                  </div>
                </div>
                <div className="md:w-1/2 md:px-8 mt-4 md:mt-0">
                  <img 
                    src={event.image} 
                    alt={event.alt} 
                    className="rounded-lg shadow-md w-full"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>


      </div>
    </section>
  );
}
